import {
  Autocomplete,
  Dialog,
  DialogContent,
  IconButton,
  InputAdornment,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useContext, useEffect, useState } from "react";
import { TextFieldMA } from "../../styles/styledComponents";
import { theme } from "../../styles/theme";
import { font } from "../../styles/font";
import EditIcon from "@mui/icons-material/Edit";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import validator from "validator";
import { ApplicationContext } from "../../context/application_ctx";
import {
  updatePassword,
  updatePersonalDetails,
} from "../../api/controllers/userController";
import { HttpStatusCode } from "axios";
import { GlobalSnackBar } from "../../components/snackBar";
import { stringToArray, stringToColor } from "../../utility/string";
import { useNavigate } from "react-router-dom";

export const UserProfileDetail = ({ admin }) => {
  const { profileDetails, setProfileDetails } = useContext(ApplicationContext);
  const profileQuery = useMediaQuery("(max-width:1082px)");
  const [profileSnack, setProfileSnack] = useState(false);
  const [error, setError] = useState("");

  console.log(profileDetails, "getderails");

  // const handleClose = () => {
  //   setSubDialog(false);
  //   setSubscriptionNav(false);
  // };

  return (
    <>
      <Box
        display="flex"
        width="100%"
        height="100%"
        flexDirection="column"
        gap="21px"
        sx={{ height: "fit-content" }}
      >
        {/* banner */}
        <Box
          display="flex"
          alignItems="center"
          // border={"1px solid rgb(229, 234, 242)"}
          border={`1px solid ${theme.col_2_alpha}`}
          width="100%"
          height="100%"
          // height="409px"
          paddingBottom="18px"
          borderRadius="8px"
          backgroundColor={theme.col_4}
          flexDirection="column"
        >
          <Box
            sx={{
              backgroundImage:
                "url(https://mindamigo.com/wp-content/uploads/2023/04/abous-us-mindamigo-min.png)",
              backgroundSize: "cover",
            }}
            display="flex"
            alignItems="center"
            width="100%"
            height="227px"
            borderRadius="8px 8px 0px 0px"
            flexDirection="column"
          ></Box>
          <Box
            display="flex"
            alignItems={profileQuery ? "flex-start" : "center"}
            width="93%"
            flex="1"
            backgroundColor={theme.col_4}
            flexDirection={profileQuery ? "column" : "row"}
          >
            <Box
              display="flex"
              alignItems="center"
              position="relative"
              top="-13px"
              gap="12px"
              
            >
              <Box
                display="flex"
                alignItems="center"
                width="100px"
                height="100px"
                borderRadius="50px"
                flexDirection="column"
                justifyContent="center"
                backgroundColor={stringToColor(profileDetails?.name ?? "green")}
              >
                <Typography
                  fontFamily={font.family.fm_2}
                  fontSize={font.size.fs_1}
                  fontWeight="bold"
                  color={theme.col_4}
                  textTransform="capitalize"
                >
                  {stringToArray(profileDetails?.name ?? "green")}
                </Typography>
              </Box>
              <Box
                display="flex"
                alignItems="flex-start"
                justifyContent="center"
                flexDirection="column"
                overflow='hidden'
              >
                <Typography
                  fontFamily={font.family.fm_2}
                  fontSize={font.size.fs_5}
                  fontWeight="bold"
                  color={theme.col_2}
                  textTransform="capitalize"
                  overflow='hidden'
                  whiteSpace='nowrap'
                  textOverflow='ellipsis'
                >
                  {profileDetails?.name}
                </Typography>
                <Typography
                  fontFamily={font.family.fm_2}
                  fontSize={font.size.fs_3}
                  color={theme.col_3}
                  textTransform="capitalize"
                >
                  {profileDetails?.jobTitle}
                </Typography>
              </Box>
            </Box>
            <Box
              display="flex"
              flex="1"
              alignItems="center"
              gap="52px"
              justifyContent="flex-end"
            >
              {/* {Array.of("Dashboard", "Registered User", "Revoked").map(
                (tabItem, i) => {
                  return (
                    <Box
                      display="flex"
                      alignItems="center"
                      onClick={() => setTabs(i)}
                      height="35px"
                      sx={{
                        ":hover": {
                          borderBottom:
                            tabs !== i
                              ? `2px solid ${theme.col_3_alpha}`
                              : `2px solid ${theme.col_3}`,
                        },
                        cursor: "pointer",
                      }}
                      borderBottom={
                        tabs === i
                          ? `2px solid ${tabs === i ? theme.col_3 : theme.col_6}`
                          : "none"
                      }
                    >
                      <Typography
                        fontFamily={font.family.fm_2}
                        fontSize={font.size.fs_3}
                        color={tabs === i ? theme.col_3 : theme.col_6}
                      >
                        {tabItem}
                      </Typography>
                    </Box>
                  );
                }
              )} */}
            </Box>
          </Box>
        </Box>

        {/* <Box display={profileQuery ? "column" : "flex"} width="100%" height="100%" gap="12px"> */}

        {/* profile */}
        <Box
          display={"flex"}
          height="100%"
          width="100%"
          // width={profileQuery ? "100%" : "50%"}
          // border={`1px solid ${theme.bgBorder}`}
          border={`1px solid ${theme.col_2_alpha}`}
          borderRadius="8px"
          backgroundColor={theme.col_4}
          gap="70px"
          flexDirection={profileQuery ? "column" : "row"}
          // alignItems="center"
          padding="22px"
          // border="2px solid blue"
        >
          <UserInfoTab
            admin={admin}
            setProfileSnack={setProfileSnack}
            setError={setError}
            profileDetails={profileDetails}
            setProfileDetails={setProfileDetails}
          />
          {admin ? (
            <></>
          ) : (
            <UserInfoPassword
              admin={admin}
              profileQuery={profileQuery}
              setProfileSnack={setProfileSnack}
              setError={setError}
              profileDetails={profileDetails}
              setProfileDetails={setProfileDetails}
            />
          )}
        </Box>

        {/* </Box> */}
      </Box>
      <GlobalSnackBar
        open={profileSnack}
        title={error}
        close={setProfileSnack}
      />
      {/* <SubscriptionDialog
        setSubDialog={setSubDialog}
        setSubscriptionNav={setSubscriptionNav}
        subscriptionNav={subscriptionNav}
        setError={setError}
        upgrade={true}
        subDialog={subDialog}
        handleClose={handleClose}
        setProfileSnack={setProfileSnack}
      /> */}
    </>
  );
};

export const UserInfoTab = ({
  profileDetails,
  setProfileSnack,
  setError,
  admin,
}) => {
  const { setGlobalLoader } = useContext(ApplicationContext);

  const [isEditProfile, setIsEditProfile] = useState(false);

  console.log(profileDetails, "profileDetails");
  useEffect(() => {
    //setGlobalLoader(true);
    setTimeout(() => {
      setGlobalLoader(false);
    }, 2000);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Box
        display={"flex"}
        // width="50%"
        flex="1"
        // gap="15px"
        // height={"25px"}
        flexDirection="column"
        gap={1}
        overflow='hidden'

        // alignItems="center"
        // border="2px solid blue"
      >
        {/* info heading */}
        <Box
          display={"flex"}
          // width="100%"
          flex="1"
          gap="15px"
          // minHeight={"40px"}
          // maxHeight={"40px"}
          // paddingLeft="11px"
          // paddingRight="11px"
          alignItems="flex-start"
          // backgroundColor={theme.col_2_alpha}
          borderRadius="6px"
        >
          <Typography
            // padding="6px 6px 6px 11px"
            flex="1"
            fontSize={font.size.fs_5}
            color={theme.col_2}
            fontFamily={font.family.fm_2}
            fontWeight="bold"
          >
            Information
          </Typography>

          {admin ? (
            <></>
          ) : (
            <IconButton onClick={() => setIsEditProfile(true)}>
              <EditIcon sx={{ fontSize: "22px", color: theme.col_3 }} />
            </IconButton>
          )}
        </Box>

        {/* info body */}
        <Box
          display="flex"
          width="100%"
          flexDirection={"column"}
          gap={1}
          alignItems="flex-start"
        >
          <Box display="flex"  width="100%" gap={1}>
            <FieldHeading>Name</FieldHeading>
            <FieldValue>{profileDetails?.name}</FieldValue>
          </Box>

          <Box display="flex" width="100%" gap={1}>
            <FieldHeading>Email</FieldHeading>
            <FieldValue>{profileDetails?.email}</FieldValue>
          </Box>

          <Box display="flex" width="100%" gap={1}>
            <FieldHeading>Job Title</FieldHeading>
            <FieldValue>{profileDetails?.jobTitle}</FieldValue>
          </Box>

          <Box display="flex" width="100%" gap={1}>
            <FieldHeading>Phone</FieldHeading>
            {/* <FieldValue>{profileDetails?.phoneNumber?.replace(/[^+0-9]/, "")}</FieldValue> */}
            <FieldValue>{profileDetails?.phoneNumber}</FieldValue>
          </Box>
        </Box>

        {isEditProfile && (
          <UpdateInfoDialog
            setError={setError}
            setProfileSnack={setProfileSnack}
            isEditProfile={isEditProfile}
            setIsEditProfile={setIsEditProfile}
          />
        )}
      </Box>

      {/* <Box
        display={"flex"}
        width="100%"
        gap="15px"
        // height={"25px"}
        flexDirection="column"
        mt={2}
      // alignItems="center"
      >
        <Box
          display={"flex"}
          // width="100%"
          flex="1"
          gap="15px"
          minHeight={"40px"}
          maxHeight={"40px"}
          paddingLeft="11px"
          paddingRight="11px"
          alignItems="center"
          backgroundColor={theme.col_3_alpha}
          borderRadius="6px"
        >
          <Typography
            // padding="6px 6px 6px 11px"
            flex="1"
            fontSize={font.size.fs_6}
            color={theme.col_3}
            fontFamily={font.family.fm_2}
            fontWeight="bold"
          >
            Change Password
          </Typography>
          {editUserProfile.password ? (
            <IconButton
              onClick={() =>
                setEditUserProfile({ ...editUserProfile, password: false })
              }
            >
              <EditIcon sx={{ fontSize: "22px", color: theme.col_3 }} />
            </IconButton>
          ) : (
            <>
              <Typography
                onClick={() =>
                  setEditUserProfile({ ...editUserProfile, password: true })
                }
                // padding="6px 6px 6px 11px"
                fontSize={font.size.fs_6}
                color={theme.col_3}
                fontFamily={font.family.fm_2}
                fontWeight="bold"
                sx={{ cursor: "pointer" }}
              >
                Save
              </Typography>
              <Typography
                // padding="6px 6px 6px 11px"
                fontSize={font.size.fs_6}
                color={theme.col_2}
                fontFamily={font.family.fm_2}
                fontWeight="bold"
                sx={{ cursor: "pointer" }}
              >
                Cancel
              </Typography>
            </>
          )}
        </Box>
        <Box
          display="flex"
          width="100%"
          flexDirection={"column"}
          gap="16px"
          justifyContent="center"
        >
          <TextFieldMA
            size="small"
            disabled={editUserProfile.password}
            type={visibility.password ? "text" : "password"}
            required
            error={
              password === null
                ? false
                : !validator.isStrongPassword(password) && password !== ""
                  ? true
                  : password === ""
                    ? true
                    : false
            }
            helperText={
              password === null
                ? ""
                : !validator.isStrongPassword(password) && password !== ""
                  ? "Password must be strong"
                  : password === ""
                    ? "Password is required"
                    : ""
            }
            onBlur={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() =>
                      setVisiblity({
                        ...visibility,
                        password: !visibility.password,
                      })
                    }
                  >
                    {visibility.password ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            fullWidth
            label="Password"
          />
          <TextFieldMA
            size="small"
            disabled={editUserProfile.password}
            required
            type={visibility.confirmPassword ? "text" : "password"}
            error={
              confirmPassword === null
                ? false
                : password !== confirmPassword
                  ? true
                  : confirmPassword === ""
                    ? true
                    : false
            }
            helperText={
              confirmPassword === null
                ? ""
                : password !== confirmPassword && confirmPassword !== ""
                  ? "Password not matching"
                  : confirmPassword === ""
                    ? "Confirm password is required"
                    : ""
            }
            onBlur={(e) => setConfirmPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() =>
                      setVisiblity({
                        ...visibility,
                        confirmPassword: !visibility.confirmPassword,
                      })
                    }
                  >
                    {visibility.confirmPassword ? (
                      <VisibilityOff />
                    ) : (
                      <Visibility />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            fullWidth
            label="Confirm Password"
          />
        </Box>
      </Box> */}
    </>
  );
};

const UserInfoPassword = ({ setError, profileQuery, setProfileSnack }) => {
  const navigate = useNavigate();

  const [visibility, setVisiblity] = useState({
    password: false,
    confirmPassword: false,
  });

  const [confirmPassword, setConfirmPassword] = useState(null);

  const [password, setPassword] = useState(null);

  const handleUpdateChangePassword = async () => {
    // if (!password) {
    //   setPassword("");
    // }

    // if (!confirmPassword) {
    //   setConfirmPassword("");
    // }
    if (
      confirmPassword !== password &&
      password &&
      validator.isStrongPassword(confirmPassword ?? "")
    ) {
      console.log("apicalledpass");
      try {
        let response = await updatePassword({
          oldPassword: password,
          newPassword: confirmPassword,
        });
        if (response.status === HttpStatusCode.Ok) {
          // setEditUserProfile(false);
          setError("Password changed successfully , please login again");
          setProfileSnack(true);
          setTimeout(() => {
            localStorage.clear();
            navigate("/signin");
          }, 2000);
        }
        if (response.status === HttpStatusCode.InternalServerError) {
          setError(response.data.message);
          setProfileSnack(true);
        }
        console.log(response, "changepassword");
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <>
      <Box
        display="flex"
        // width="50%"
        flex="1"
        // flexDirection={"column"}
        gap={4}
        justifyContent="center"
        flexWrap="wrap"
        // border="2px solid blue"
      >
        <Box
          display={"flex"}
          // width="100%"
          flex="1"
          gap="15px"
          minHeight={"40px"}
          maxHeight={"40px"}
          // paddingLeft="11px"
          // paddingRight="11px"
          alignItems="center"
          // backgroundColor={theme.col_3_alpha}
          borderRadius="6px"
          position="sticky"
          top={0}
          bgcolor={theme.col_4}
        >
          <Typography
            // padding="6px 6px 6px 11px"
            flex="1"
            fontSize={font.size.fs_5}
            color={theme.col_2}
            fontFamily={font.family.fm_2}
            fontWeight="bold"
          >
            Change account password
          </Typography>

          <Typography
            onClick={() => {
              handleUpdateChangePassword();
              // setEditUserProfile({ ...editUserProfile, user: true });
            }}
            // padding="6px 6px 6px 11px"
            fontSize={font.size.fs_6}
            color={theme.col_3}
            fontFamily={font.family.fm_2}
            fontWeight="bold"
            sx={{ cursor: "pointer" }}
          >
            Save
          </Typography>

          {/* <Typography
                        // onClick={handleUserInfoCancel}
                        // padding="6px 6px 6px 11px"
                        fontSize={font.size.fs_6}
                        color={theme.col_2}
                        fontFamily={font.family.fm_2}
                        fontWeight="bold"
                        sx={{ cursor: "pointer" }}
                      >
                        Cancel
                      </Typography> */}
        </Box>
        <Box
          display="flex"
          flexDirection={profileQuery ? "column" : "row"}
          gap={1}
          width="100%"
        >
          <Box display="flex" flexDirection="column" gap={1} width="100%">
            <Typography fontWeight="bold" color={theme.col_6}>
              Current Password
            </Typography>
            <TextFieldMA
              // disabled
              size="small"
              // disabled={editUserProfile.user}
              type={visibility.password ? "text" : "password"}
              required
              error={
                password === null
                  ? false
                  : password === confirmPassword
                  ? true
                  : password === ""
                  ? true
                  : false
              }
              helperText={
                password === null
                  ? ""
                  : password === confirmPassword
                  ? "Password can't be same"
                  : password === ""
                  ? "Password is required"
                  : ""
              }
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      // disabled={editUserProfile.user}
                      onClick={() =>
                        setVisiblity({
                          ...visibility,
                          password: !visibility.password,
                        })
                      }
                    >
                      {visibility.password ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              fullWidth
              placeholder="Current Password"
            />
          </Box>

          <Box display="flex" flexDirection="column" gap={1} width="100%">
            <Typography fontWeight="bold" color={theme.col_6}>
              New Password
            </Typography>
            <TextFieldMA
              size="small"
              // disabled
              // disabled={editUserProfile.user}
              required
              type={visibility.confirmPassword ? "text" : "password"}
              error={
                confirmPassword === null
                  ? false
                  : !validator.isStrongPassword(confirmPassword)
                  ? true
                  : confirmPassword === ""
                  ? true
                  : false
              }
              helperText={
                confirmPassword === null
                  ? ""
                  : !validator.isStrongPassword(confirmPassword)
                  ? "Password must be strong"
                  : confirmPassword === ""
                  ? "Confirm password is required"
                  : ""
              }
              onChange={(e) => setConfirmPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      // disabled={editUserProfile.user}
                      onClick={() =>
                        setVisiblity({
                          ...visibility,
                          confirmPassword: !visibility.confirmPassword,
                        })
                      }
                    >
                      {visibility.confirmPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              fullWidth
              placeholder="New Password"
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export const FieldHeading = (props) => {
  console.log(props, props.children, "props");
  return (
    <Typography
      fontWeight="bold"
      textOverflow="ellipsis"
      overflow="hidden"
      whiteSpace="nowrap"
      color={theme.col_6}
      {...props}
    >
      {props.children}:
    </Typography>
  );
};

export const FieldValue = (props) => {
  console.log(props, props.children, "props");
  return (
    <Typography
      color={theme.col_6}
      textOverflow="ellipsis"
      overflow="hidden"
      whiteSpace="nowrap"
      {...props}
    >
      {props.children}
    </Typography>
  );
};

const UpdateInfoDialog = ({
  isEditProfile,
  setIsEditProfile,
  setError,
  setProfileSnack,
}) => {
  // const navigate = useNavigate();

  const { profileDetails, setProfileDetails, setGlobalLoader } =
    useContext(ApplicationContext);

  // const [visibility, setVisiblity] = useState({
  //   password: false,
  //   confirmPassword: false,
  // });
  // const [loaderState, setLoaderState] = useState(false);
  const [name, setName] = useState(profileDetails?.name);
  const [email, setEmail] = useState(profileDetails?.email);
  // const [confirmPassword, setConfirmPassword] = useState(null);
  const [phoneNoRegex, setPhoneNoRegex] = useState(
    `${profileDetails?.phoneNumber}`
  );
  // const [password, setPassword] = useState(null);
  const [editUserProfile, setEditUserProfile] = useState({
    user: true,
    password: true,
  });
  const jobTitles = [
    { title: "Director", id: 0 },
    { title: "CEO", id: 1 },
    { title: "Manager", id: 2 },
  ];
  let jobValue;
  jobTitles.map((data) => {
    if (data?.title === profileDetails?.jobTitle) {
      jobValue = data;
    }
    return false;
  });
  console.log(jobValue, profileDetails.jobTitle, "jobdata");
  const [getJobTitle, setJobtitle] = useState(jobValue);

  console.log(name, email, phoneNoRegex, getJobTitle);

  const handleUserInfoCancel = () => {
    setName(profileDetails?.name);
    setEmail(profileDetails?.email);
    setPhoneNoRegex(`${profileDetails?.phoneNumber}`);
    setJobtitle(jobValue);
    setEditUserProfile({ ...editUserProfile, user: true, password: true });

    setIsEditProfile(false);
  };

  const checkIfValuesEqual = () => {
    if (
      name === profileDetails?.name &&
      getJobTitle?.title === profileDetails?.jobTitle &&
      phoneNoRegex?.toString() === profileDetails?.phoneNumber?.toString()
    ) {
      console.log("same");
      return true;
    } else {
      return false;
    }
  };

  const handleUpdateUserDetails = async () => {
    // setLoginNavigation(3);
    // if (!profileDetails?.companyAddress) {
    //   profileDetails.companyAddress = "";
    // }

    // setProfileDetails({ ...profileDetails });

    // console.log(name === profileDetails?.name, "name equal")
    // console.log(getJobTitle.title === profileDetails?.jobTitle, "jobtitle equal")
    // console.log(phoneNoRegex.toString() === profileDetails?.phoneNumber.toString(), "phone number")
    // console.log(phoneNoRegex, profileDetails?.phoneNumber, "phone number value")

    // if (name === profileDetails?.name && getJobTitle.title === profileDetails?.jobTitle && phoneNoRegex.toString() === profileDetails?.phoneNumber.toString()) {
    //   console.log("same")
    //   return;
    // }

    let sameValue = checkIfValuesEqual();
    if (sameValue) {
      return;
    }

    console.log("yes ready to send");

    let body = {
      name: name,
      jobTitle: getJobTitle?.title,
      phoneNumber: phoneNoRegex,
    };

    console.log(body, "body");

    if (name === profileDetails?.name) {
      delete body["name"];
    }

    if (getJobTitle?.title === profileDetails?.jobTitle) {
      delete body["jobTitle"];
    }

    if (phoneNoRegex === profileDetails?.phoneNumber) {
      delete body["phoneNumber"];
    }

    console.log(body, "body after");

    let token = localStorage.getItem("api-token");
    try {
      // setLoaderState(true);

      let response = await updatePersonalDetails(body, token);
      console.log(response, "response update");
      // setLoaderState(false);

      if (response.status === HttpStatusCode.Ok) {
        setProfileDetails(response.data.updatedOrganization);
        // setCompanyDetails(response.data.updatedOrganization);
        // setIsCompanyProfileEdit({ ...isCompanyProfileEdit, address: false });

        setIsEditProfile(false);

        setError(response.data.message);
        setProfileSnack(true);
      }
      if (response.status === HttpStatusCode.BadRequest) {
        setError(response.data.message);
        setProfileSnack(true);
      }
      if (response.status === HttpStatusCode.Unauthorized) {
        setError(response.data.message);
        setProfileSnack(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    //setGlobalLoader(true);
    setTimeout(() => {
      setGlobalLoader(false);
    }, 2000);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // const handleUpdateChangePassword = async () => {
  //   if (!password) {
  //     setPassword("");
  //   }

  //   if (!confirmPassword) {
  //     setConfirmPassword("");
  //   }
  //   if (
  //     confirmPassword !== password &&
  //     password &&
  //     validator.isStrongPassword(confirmPassword)
  //   ) {
  //     console.log("apicalledpass");
  //     try {
  //       let response = await updatePassword({
  //         oldPassword: password,
  //         newPassword: confirmPassword,
  //       });
  //       if (response.status === HttpStatusCode.Ok) {
  //         setEditUserProfile(false);
  //         setError("Password changed successfully , please login again");
  //         setProfileSnack(true);
  //         setTimeout(() => {
  //           localStorage.clear();
  //           navigate("/signin");
  //         }, 2000);
  //       }
  //       if (response.status === HttpStatusCode.InternalServerError) {
  //         setError(response.data.message);
  //         setProfileSnack(true);
  //       }
  //       console.log(response, "changepassword");
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   }
  // };

  return (
    <Dialog
      open={editUserProfile}
      sx={{
        "& .MuiDialog-paper": {
          minWidth: "60%",
          //  minHeight: "60vh"
        },
      }}
    >
      {/* <DialogTitle>
        <Box
          display={"flex"}
          alignItems="center"
          justifyContent="flex-end"
          px={2}
          >
          <Typography
            // padding="6px 6px 6px 11px"
            flex="1"
            fontSize={font.size.fs_5}
            color={theme.col_2}
            fontFamily={font.family.fm_2}
            fontWeight="bold"
          >
            Profile Edit
          </Typography>
          <IconButton onClick={() => setIsEditProfile(false)} sx={{ ml: "auto" }}>
            <Close sx={{ fontSize: "22px", color: theme.col_3 }} />
          </IconButton>
        </Box>
      </DialogTitle> */}

      <DialogContent>
        <Box
          display={"flex"}
          flexDirection="column"
          gap={2}
          height="100%"
          width="100%"
          // pt={2}
        >
          {/* user info */}
          <Box display={"flex"} flexDirection="column" gap={2} px={2}>
            <Box
              display={"flex"}
              // width="100%"
              flex="1"
              gap="15px"
              minHeight={"40px"}
              maxHeight={"40px"}
              // paddingLeft="11px"
              // paddingRight="11px"
              alignItems="center"
              // backgroundColor={theme.col_3_alpha}
              borderRadius="6px"
              position="sticky"
              top={0}
              bgcolor={theme.col_4}
            >
              <Typography
                // padding="6px 6px 6px 11px"
                flex="1"
                fontSize={font.size.fs_5}
                color={theme.col_2}
                fontFamily={font.family.fm_2}
                fontWeight="bold"
              >
                Information
              </Typography>
              {false ? (
                <IconButton
                  onClick={() =>
                    setEditUserProfile({ ...editUserProfile, user: false })
                  }
                >
                  <EditIcon sx={{ fontSize: "22px", color: theme.col_3 }} />
                </IconButton>
              ) : (
                <>
                  <Typography
                    onClick={() => {
                      handleUpdateUserDetails();
                      // setEditUserProfile({ ...editUserProfile, user: true });
                    }}
                    // padding="6px 6px 6px 11px"
                    fontSize={font.size.fs_6}
                    color={
                      checkIfValuesEqual() === true
                        ? theme.statusDisabled
                        : theme.col_3
                    }
                    fontFamily={font.family.fm_2}
                    fontWeight="bold"
                    sx={{ cursor: "pointer" }}
                  >
                    Save
                  </Typography>

                  <Typography
                    onClick={handleUserInfoCancel}
                    // padding="6px 6px 6px 11px"
                    fontSize={font.size.fs_6}
                    color={theme.col_2}
                    fontFamily={font.family.fm_2}
                    fontWeight="bold"
                    sx={{ cursor: "pointer" }}
                  >
                    Cancel
                  </Typography>
                </>
              )}
            </Box>

            <Box
              display="flex"
              flexDirection="column"
              gap={4}
              pb={1}
              sx={{ overflowY: "auto" }}
            >
              <Box
                display="flex"
                width="100%"
                // flexDirection={"column"}
                gap={4}
                justifyContent="center"
                flexWrap="wrap"
                // border="2px solid blue"
              >
                <Box display="flex" flexDirection="column" gap={1} width="100%">
                  <Typography fontWeight="bold" color={theme.col_6}>
                    Name
                  </Typography>
                  <TextFieldMA
                    id="name"
                    // defaultValue={profileDetails?.name}
                    value={name}
                    // disabled={editUserProfile.user}
                    size="small"
                    inputProps={{maxLength:30}}
                    required
                    onChange={(e) => setName(e.target.value)}
                    fullWidth
                    placeholder="Name"
                  />
                </Box>

                <Box display="flex" flexDirection="column" gap={1} width="100%">
                  <Typography fontWeight="bold" color={theme.col_6}>
                    Email
                  </Typography>
                  <TextFieldMA
                    id="email"
                    disabled={true}
                    defaultValue={profileDetails?.email}
                    // disabled={editUserProfile.user}
                    size="small"
                    required
                    error={
                      email === null
                        ? false
                        : !validator.isEmail(email) && email !== ""
                        ? true
                        : // : email === ""
                          // ? true
                          false
                    }
                    helperText={
                      email === null
                        ? ""
                        : !validator.isEmail(email) && email !== ""
                        ? "Enter valid email"
                        : // : email === ""
                          // ? "Email is required"
                          ""
                    }
                    onChange={(e) => setEmail(e.target.value)}
                    fullWidth
                    placeholder="Email"
                  />
                </Box>
              </Box>

              <Box
                display="flex"
                width="100%"
                // flexDirection={"column"}
                gap={4}
                justifyContent="center"
                flexWrap="wrap"
                // border="2px solid blue"
              >
                <Box display="flex" flexDirection="column" gap={1} width="100%">
                  <Typography fontWeight="bold" color={theme.col_6}>
                    Job Title
                  </Typography>
                  <Autocomplete
                    // disabled={editUserProfile?.user}
                    size="small"
                    fullWidth
                    defaultValue={getJobTitle}
                    disablePortal
                    onChange={(event, newValue) => {
                      setJobtitle(newValue);
                      // console.log(newValue)
                    }}
                    isOptionEqualToValue={(option, val) =>
                      option?.id === val?.id
                    }
                    // value={getJobTitle}
                    // onInputChange={(event, newInputValue) => {
                    //   console.log(newInputValue, "oninput");
                    // }}
                    options={jobTitles}
                    getOptionLabel={(option) => option?.title}
                    renderInput={(params) => (
                      <TextFieldMA
                        error={getJobTitle === null ? true : false}
                        helperText={
                          getJobTitle === null ? "Job Title is required" : ""
                        }
                        size="small"
                        fullwidth
                        {...params}
                        // label="Job Title"
                        placeholder="Job Title"
                      />
                    )}
                  />
                </Box>

                <Box display="flex" flexDirection="column" gap={1} width="100%">
                  <Typography fontWeight="bold" color={theme.col_6}>
                    Phone No
                  </Typography>
                  <TextFieldMA
                    id="phoneNo"
                    // disabled={editUserProfile.user}
                    size="small"
                    // required
                    // defaultValue={profileDetails?.phoneNumber}
                    value={phoneNoRegex?.replace(/[^+0-9]/, "")}
                    error={
                      phoneNoRegex === null
                        ? false
                        : !validator.isMobilePhone(phoneNoRegex) &&
                          phoneNoRegex !== ""
                        ? true
                        : false
                    }
                    helperText={
                      phoneNoRegex === null
                        ? ""
                        : !validator.isMobilePhone(phoneNoRegex) &&
                          phoneNoRegex !== ""
                        ? "Enter valid phone number"
                        : ""
                    }
                    // onBlur={(e) => setPhoneNo(e.target.value)}
                    onChange={(e) =>
                      setPhoneNoRegex(e.target.value.replace(/[^+0-9]/, ""))
                    }
                    fullWidth
                    placeholder="Phone No"
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
